import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "grid flex flex--wrap flex--justify-space-between flex--align-center" }
const _hoisted_2 = { class: "grid__item a4-12 c6-12 f6-6" }
const _hoisted_3 = { class: "form__set" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "first_name",
  class: "form__label"
}, " First name ", -1 /* HOISTED */)
const _hoisted_5 = {
  key: 0,
  class: "form__error"
}
const _hoisted_6 = { class: "form__set" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "last_name",
  class: "form__label"
}, " Last name ", -1 /* HOISTED */)
const _hoisted_8 = {
  key: 0,
  class: "form__error"
}
const _hoisted_9 = { class: "form__set" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form__label"
}, " Email ", -1 /* HOISTED */)
const _hoisted_11 = { class: "form__set" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "photo",
  class: "form__label"
}, " Upload a new photo ", -1 /* HOISTED */)
const _hoisted_13 = { class: "form__file-container" }
const _hoisted_14 = { class: "form__file-button" }
const _hoisted_15 = { class: "form__selected-file" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "form__selected-file-name" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "form__file-icon icon icon--upload" }, null, -1 /* HOISTED */)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "form__file-instruction" }, " Select a file or drag and drop here ", -1 /* HOISTED */)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "form__file-browse" }, "Browse", -1 /* HOISTED */)
const _hoisted_21 = { key: 0 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers((...args) => ($options.updateProfile && $options.updateProfile(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            id: "first_name",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.form_fields.first_name) = $event)),
            class: "form__input form__input--stretch",
            type: "text",
            name: "first_name"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $data.form_fields.first_name]
          ]),
          (this.errors.first_name)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(this.errors.first_name), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            id: "last_name",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.form_fields.last_name) = $event)),
            class: "form__input form__input--stretch",
            type: "text",
            name: "last_name"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $data.form_fields.last_name]
          ]),
          (this.errors.last_name)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(this.errors.last_name), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("p", null, _toDisplayString($setup.user_profile.email), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              ($data.form_fields.photo)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("img", {
                        src: $data.form_fields.photo.base64,
                        alt: ""
                      }, null, 8 /* PROPS */, _hoisted_16)
                    ]),
                    _createElementVNode("p", _hoisted_17, _toDisplayString($data.form_fields.photo.name), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              _hoisted_18,
              _hoisted_19,
              _hoisted_20,
              _createElementVNode("input", {
                id: "photo",
                ref: "photo",
                type: "file",
                name: "photo",
                class: "form__file-input",
                accept: "image/jpg, image/png",
                onInput: _cache[2] || (_cache[2] = (...args) => ($options.updatePhotoField && $options.updatePhotoField(...args)))
              }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */)
            ])
          ])
        ]),
        (_ctx.error_message)
          ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.error_message), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("button", {
          class: _normalizeClass(["button button--fill mt-32", { 'button--loading' : $data.loading }]),
          type: "submit"
        }, " Save ", 2 /* CLASS */)
      ], 32 /* HYDRATE_EVENTS */)
    ])
  ]))
}